export const environment = {
  production: false,
  eliquaRestURL: 'https://ms.uat.qivos.net/ci-ms-UAT/rest/v1/',
  clientName: 'ms',
};
